import { createAction } from '@reduxjs/toolkit';

export const setViewedProduct = createAction('products/setViewedProduct', (viewedProduct) => ({
  payload: {
    viewedProduct,
  },
}));

export const setProductsList = createAction('products/setProductsList', (productsList) => ({
  payload: {
    productsList,
  },
}));

export const fetchSingleProduct = createAction('products/fetchSingleProduct', (productId) => ({
  payload: {
    productId,
  },
}));

export const fetchProductsData = createAction('products/fetchProductsData', (filterName, filterValue) => ({
  payload: {
    filterName,
    filterValue,
  },
}));

export const deleteProduct = createAction('products/deleteProduct', (productId) => ({
  payload: {
    productId,
  },
}));
